import { EventBus } from 'events/EventBus';
import { PainterMode } from 'constants/painterModes';
import { PainterToolType, MeasureToolType } from 'constants/painterTypes';
import {
  ActivityEvent,
  InteractiveObjectEvent,
  ReaderEvent,
  ReaderToolsEvent,
  CanvasEvent
} from 'events/EventTypes';
import {
  ReaderToolType,
  ReaderZoomType,
  SideBarType
} from 'constants/ReaderTools';
import { BookFlipType } from 'constants/flipTypes';

const closeToolbox = () => {
  EventBus.emit({
    event: ReaderToolsEvent.ClickReaderToolBoxEvent,
    payload: {
      isToolboxShow: false
    }
  })
}

const changePainterMode = ({ event, painterMode, painterToolType }) => {
  EventBus.emit({ event, payload: { painterMode, painterToolType } });
  closeToolbox();
};

const addImageClickHandler = e => {
  EventBus.emit({
    event: ReaderToolsEvent.ClickInsertImageEvent,
    payload: { painterMode: PainterMode.InsertImage }
  });
  setReaderToolType(ReaderToolType.Img);
};

const addTextClickHandler = e => {
  EventBus.emit({
    event: ReaderToolsEvent.ClickInsertTextEvent,
    payload: { painterMode: PainterMode.InsertText }
  });
  setReaderToolType(ReaderToolType.Text);
};

const toggleBookmarkHandler = e => {
  EventBus.emit({
    event: ReaderToolsEvent.ToggleBookmarkEvent
  });
  closeToolbox();
};

const toggleActivityPanel = () => {
  EventBus.emit({
    event: ActivityEvent.ToggleActivityPanelEvent,
    payload: {}
  });
  closeToolbox();
};

const setReaderToolType = type => {
  EventBus.emit({
    event: ReaderToolsEvent.SetReaderToolTypeEvent,
    payload: {
      readerToolType: type
    }
  });
  type !== ReaderToolType.Toolbox && closeToolbox();
}

const toggleSideBarHandler = sideBarType => e => {
  EventBus.emit({
    event: ReaderToolsEvent.ToggleSideBarEvent,
    payload: { sideBarType }
  });
  closeToolbox();
};

const toggleFullScreen = () => {
  EventBus.emit({
    event: ReaderToolsEvent.ToggleFullScreen
  });
}

export default {
  [ReaderToolType.Expression]: {
    title: '表情',
    ga: '工具列_表情',
    clickHandler: () => {
      EventBus.emit({
        event: ReaderToolsEvent.ClickDragEvent
      });
      setReaderToolType(ReaderToolType.Drag);
    },
    icon: 'Expression',
  },
  [ReaderToolType.SynchronousCamera]: {
    title: '遙控器',
    ga: '工具列_遙控器',
    clickHandler: () => {
      EventBus.emit({
        event: ReaderToolsEvent.SetSyncCameraEvent,
        payload: { isOpen: null },
      });
      setReaderToolType(ReaderToolType.Drag);
    },
    icon: 'Remote',
  },
  [ReaderToolType.BackToCatalog]: {
    // title: '回目次',
    title: 'ReaderToolTitle_BackToCatalog',
    ga: '工具列_回目次',
    clickHandler: () => {
      EventBus.emit({ event: ReaderEvent.GoBackCatalogEvent });
      closeToolbox();
    },
    icon: 'ContentBack',
  },
  [ReaderToolType.StickyNote]: {
    title: '便利貼',
    ga: '工具列_便利貼',
    clickHandler: () => {
      EventBus.emit({
        event: ReaderToolsEvent.CreateCourseInteractiveItemEvent,
        payload: { painterMode: ReaderToolType.StickyNote, contentType: ReaderToolType.StickyNote, isNew: true }
      });
      setReaderToolType(ReaderToolType.StickyNote);
    },
    icon: 'StickyNote',
  },
  [ReaderToolType.Link]: {
    title: '連結',
    ga: '工具列_連結',
    clickHandler: () => {
      EventBus.emit({
        event: ReaderToolsEvent.CreateCourseInteractiveItemEvent,
        payload: { painterMode: ReaderToolType.Link, contentType: ReaderToolType.Link, isNew: true }
      });
      setReaderToolType(ReaderToolType.Link);
    },
    icon: 'Link',
  },
  [ReaderToolType.MathTools]: {
    title: '尺規作圖',
    ga: '工具列_尺規作圖',
    clickHandler: () => {
      EventBus.emit({ event: ReaderToolsEvent.ClickMathToolsEvent, payload: { mathToolsInfo: {} } });
      closeToolbox();
    },
    icon: 'MathTool',
  },
  [ReaderToolType.Bookshelf]: {
    // title: '書櫃',
    title: 'ReaderToolTitle_Bookshelf',
    ga: '工具列_書櫃',
    icon: 'Bookcase',
  },
  [ReaderToolType.Menu]: {
    // title: '目次',
    title: 'ReaderToolTitle_Menu',
    ga: '工具列_目次',
    clickHandler: toggleSideBarHandler(SideBarType.LEFT),
    icon: 'Content',
  },
  [ReaderToolType.Mark]: {
    // title: '標記文字',
    title: 'ReaderToolTitle_Mark',
    ga: '工具列_標記文字',
    clickHandler: () => {
      EventBus.emit({
        event: ReaderToolsEvent.OnMarkModeEvent
      });
      setReaderToolType(ReaderToolType.Mark)
    },
    icon: 'Mark',
  },
  [ReaderToolType.Drag]: {
    // title: '滑鼠',
    title: 'ReaderToolTitle_Mouse',
    ga: '工具列_滑鼠',
    clickHandler: () => {
      EventBus.emit({
        event: ReaderToolsEvent.ClickDragEvent
      });
      setReaderToolType(ReaderToolType.Drag);
    },
    icon: 'MouseHand',
  },
  [ReaderToolType.Select]: {
    // title: '選取',
    title: 'ReaderToolTitle_Select',
    ga: '工具列_選取',
    clickHandler: () => {
      closeToolbox();
      changePainterMode({
        event: ReaderToolsEvent.ClickSelectEvent,
        painterMode: PainterMode.Selection
      });
      setReaderToolType(ReaderToolType.Select);
    },
    icon: 'Select',
  },
  [ReaderToolType.Painting]: {
    // title: '畫筆',
    title: 'ReaderToolTitle_Painter',
    ga: '工具列_畫筆',
    clickHandler: () => {
      changePainterMode({
        event: ReaderToolsEvent.ClickPainterEvent,
        painterMode: PainterMode.Painting,
        painterToolType: PainterToolType.Pen
      });
      setReaderToolType(ReaderToolType.Painting);
    },
    icon: 'Painting',
  },
  [ReaderToolType.Highlighter]: {
    // title: '螢光筆',
    title: 'ReaderToolTitle_Highlighter',
    ga: '工具列_螢光筆',
    clickHandler: () => {
      changePainterMode({
        event: ReaderToolsEvent.ClickPainterEvent,
        painterMode: PainterMode.Painting,
        painterToolType: PainterToolType.Highlighter
      });
      setReaderToolType(ReaderToolType.Highlighter);
    },
    icon: 'Highlighter',
  },
  [ReaderToolType.Shape]: {
    // title: '形狀',
    title: 'ReaderToolTitle_Shape',
    ga: '工具列_形狀',
    clickHandler: () => {
      changePainterMode({
        event: ReaderToolsEvent.ClickPainterEvent,
        painterMode: PainterMode.Painting,
        painterToolType: PainterToolType.Shape
      });
      setReaderToolType(ReaderToolType.Shape);
    },
    icon: 'Shape',
  },
  [ReaderToolType.Line]: {
    // title: '線段',
    title: 'ReaderToolTitle_Line',
    ga: '工具列_線段',
    clickHandler: () => {
      changePainterMode({
        event: ReaderToolsEvent.ClickPainterEvent,
        painterMode: PainterMode.Painting,
        painterToolType: PainterToolType.Line
      });
      setReaderToolType(ReaderToolType.Line);
    },
    icon: 'Line',
  },
  [ReaderToolType.DeleteAll]: {
    // title: '全部刪除',
    title: 'ReaderToolTitle_DeleteAll',
    clickHandler: () => {
      EventBus.emit({ event: ReaderToolsEvent.ClickEraseAllEvent });
      closeToolbox();
    },
    icon: 'DeleteAll',
  },
  [ReaderToolType.Delete]: {
    // title: '部分刪除',
    title: 'ReaderToolTitle_Delete',
    ga: '工具列_部份刪除',
    clickHandler: () => {
      changePainterMode({
        event: ReaderToolsEvent.ClickEraserEvent,
        painterMode: PainterMode.Eraser
      })
      setReaderToolType(ReaderToolType.Delete);
    },
    icon: 'Delete',
  },
  [ReaderToolType.ArrowLeft]: {
    // title: '左翻',
    title: { [BookFlipType.LEFT_TO_RIGHT]: 'ReaderToolTitle_LeftFlip', [BookFlipType.RIGHT_TO_LEFT]: 'ReaderToolTitle_RightFlip' },
    clickHandler: (book, LRFlip) => {
      if (LRFlip === BookFlipType.LEFT_TO_RIGHT) {
        EventBus.emit({
          event: ReaderEvent.ClickPreviousPageEvent,
          payload: { convertToSVG: true, source: 'toolbar' }
        });
      } else {
        EventBus.emit({
          event: ReaderEvent.ClickNextPageEvent,
          payload: { pageInfos: book.pageInfos, convertToSVG: true, source: 'toolbar' }
        });
      }
      closeToolbox();
    },
    icon: 'ArrowLeft',
  },
  [ReaderToolType.ArrowRight]: {
    // title: '右翻',
    title: { [BookFlipType.LEFT_TO_RIGHT]: 'ReaderToolTitle_RightFlip', [BookFlipType.RIGHT_TO_LEFT]: 'ReaderToolTitle_LeftFlip' },
    clickHandler: (book, LRFlip) => {
      if (LRFlip === BookFlipType.LEFT_TO_RIGHT) {
        EventBus.emit({
          event: ReaderEvent.ClickNextPageEvent,
          payload: { pageInfos: book.pageInfos, convertToSVG: true, source: 'toolbar' }
        });
      } else {
        EventBus.emit({
          event: ReaderEvent.ClickPreviousPageEvent,
          payload: { convertToSVG: true, source: 'toolbar' }
        });
      }
      closeToolbox();
    },
    icon: 'ArrowRight',
  },
  [ReaderToolType.PageSearcher]: {
    // title: '頁數選擇',
    title: 'ReaderToolTitle_PageSearcher',
    clickHandler: () => {
      EventBus.emit({
        event: ReaderToolsEvent.TogglePageSearcherEvent
      });
      closeToolbox();
    },
    clickLeftHandler: (book, LRFlip) => {
      if (LRFlip === BookFlipType.LEFT_TO_RIGHT) {
        EventBus.emit({
          event: ReaderEvent.ClickPreviousPageEvent,
          payload: { convertToSVG: true, source: 'toolbar' }
        });
      } else {
        EventBus.emit({
          event: ReaderEvent.ClickNextPageEvent,
          payload: { pageInfos: book.pageInfos, convertToSVG: true, source: 'toolbar' }
        });
      }
      closeToolbox();
    },
    clickRightHandler: (book, LRFlip) => {
      if (LRFlip === BookFlipType.LEFT_TO_RIGHT) {
        EventBus.emit({
          event: ReaderEvent.ClickNextPageEvent,
          payload: { pageInfos: book.pageInfos, convertToSVG: true, source: 'toolbar'}
        });
      } else {
        EventBus.emit({
          event: ReaderEvent.ClickPreviousPageEvent,
          payload: { convertToSVG: true, source: 'toolbar' }
        });
      }
      closeToolbox();
    },
    icon: 'PageSearcher',
  },
  [ReaderToolType.FourZoomIn]: {
    // title: '四格放大'
    title: 'ReaderToolTitle_QuarterZoomIn',
  },
  [ReaderToolType.AllScreen]: {
    // title: '原尺寸',
    title: 'ReaderToolTitle_OriginalSize',
    ga: '工具列_原尺寸',
    clickHandler: () => {
      EventBus.emit({
        event: ReaderToolsEvent.SetReaderZoomEvent,
        payload: { type: ReaderZoomType.OriginZoom }
      })
      closeToolbox();
    },
    icon: 'AllScreen',
  },
  [ReaderToolType.IntervalZoomIn]: {
    // title: '區間放大',
    title: 'ReaderToolTitle_SectionZoomIn',
    ga: '工具列_區間放大',
    clickHandler: () => {
      EventBus.emit({
        event: ReaderEvent.DrawAreaEvent,
        payload: { drawAreaInfo: { isDrawArea: true } }
      });
      setReaderToolType(ReaderToolType.IntervalZoomIn);
    },
    icon: 'IntervalZoomIn',
  },
  [ReaderToolType.FullScreen]: {
    // title: '全螢幕',
    title: 'ReaderToolTitle_FullScreen',
    ga: '工具列_全螢幕',
    clickHandler: () => {
      toggleFullScreen();
      setReaderToolType(ReaderToolType.FullScreen);
    },
    icon: 'FullScreen',
  },
  [ReaderToolType.Whiteboard]: {
    // title: '白板',
    title: 'ReaderToolTitle_Whiteboard',
    icon: 'Whiteboard',
  },
  [ReaderToolType.NumberPicker]: {
    // title: '選號器',
    title: 'ReaderToolTitle_NumberPicker',
    icon: 'NumberPicker',
  },
  [ReaderToolType.Img]: {
    // title: '新增圖片',
    title: 'ReaderToolTitle_InsertImage',
    ga: '工具列_新增圖片',
    clickHandler: () => {
      addImageClickHandler()
    },
    icon: 'Img',
  },
  [ReaderToolType.Text]: {
    // title: '新增文字',
    title: 'ReaderToolTitle_InsertText',
    ga: '工具列_新增文字',
    clickHandler: () => {
      addTextClickHandler()
    },
    icon: 'Text',
  },
  [ReaderToolType.SVG]: {
    // title: 'SVG物件',
    title: 'ReaderToolTitle_InsertStamp',
    clickHandler: () => {
      EventBus.emit({ event: ReaderToolsEvent.ClickStampPanelEvent })
      setReaderToolType(ReaderToolType.Menu);
    },
    icon: 'SVG',
  },
  [ReaderToolType.PageMode]: {
    // title: { [true]: '單頁', [false]: '雙頁' },
    title: { [true]: 'ReaderToolTitle_SinglePageMode', [false]: 'ReaderToolTitle_DoublePageMode' },
    clickHandler: isDoublePageMode => {
      EventBus.emit({
        event: ReaderToolsEvent.TogglePageModeEvent,
        payload: { isDoublePageMode: !isDoublePageMode }
      })
      closeToolbox();
    },
    icon: { [true]: 'OnePage', [false]: 'DoublePage' }
  },
  [ReaderToolType.ReaderOption]: {
    // title: '設定',
    title: 'ReaderToolTitle_Options',
    ga: '工具列_偏好設定',
    clickHandler: () => {
      EventBus.emit({ event: ReaderToolsEvent.ClickReaderOptionPanelEvent })
      closeToolbox();
    },
    icon: 'Setup',
  },
  [ReaderToolType.Bookmark]: {
    // title: '頁籤',
    title: 'ReaderToolTitle_Bookmark',
    ga: '工具列_頁籤',
    clickHandler: () => {
      toggleBookmarkHandler()
    },
    icon: 'Bookmark',
  },
  [ReaderToolType.Activity]: {
    // title: '活動',
    title: 'ReaderToolTitle_Activity',
    clickHandler: () => {
      toggleActivityPanel()
    },
    icon: 'Activity',
  },
  [ReaderToolType.ExportInteractiveObject]: {
    // title: '匯出',
    title: 'ReaderToolTitle_ExportInteractiveObject',
    clickHandler: e => {
      EventBus.emit({
        event: InteractiveObjectEvent.ExportInteractiveObjectEvent
      });
    },
    icon: 'Save',
  },
  [ReaderToolType.AttendeeNumber]: {
    // title: '座號',
    title: 'ReaderToolTitle_AttendeeNumber',
    clickHandler: () => {
    }
  },
  [ReaderToolType.OfflineReaderToolBox]: {
    // title: '工具箱',
    title: 'ReaderToolTitle_OfflineReaderToolBox',
    clickHandler: () => {
      EventBus.emit({ event: ReaderToolsEvent.ClickOfflineReaderToolBoxEvent })
      setReaderToolType(ReaderToolType.OfflineReaderToolBox);
    },
    icon: 'MathToolBox',
  },
  [ReaderToolType.Toolbox]: {
    // title: '工具箱',
    title: 'ReaderToolTitle_Toolbox',
    clickHandler: () => {
      EventBus.emit({
        event: ReaderToolsEvent.ClickReaderToolBoxEvent,
        payload: {
          isToolboxShow: true
        }
      })
      setReaderToolType(ReaderToolType.Toolbox);
    },
    icon: 'ToolBox',
  },
  [ReaderToolType.Timer]: {
    // title: '計時器',
    title: 'ReaderToolTitle_Timer',
    icon: 'Timer',
  },
  [ReaderToolType.Stopwatch]: {
    // title: '馬表',
    title: 'ReaderToolTitle_Stopwatch',
    icon: 'Stopwatch',
  },
  [ReaderToolType.MeasureTools]: {
    // title: '測量工具',
    title: 'ReaderToolTitle_MeasureTools',
    ga: '工具列_測量工具',
    clickHandler: () => {
      changePainterMode({
        event: ReaderToolsEvent.ClickPainterEvent,
        painterMode: PainterMode.MeasureTools,
        painterToolType: PainterToolType.Pen
      });
      setReaderToolType(ReaderToolType.MeasureTools);
    },
    icon: 'MeasureTools',
  },
  [ReaderToolType.Protractor]: {
    // title: '量角器',
    title: 'ReaderToolTitle_Protractor',
    ga: '工具列_測量工具_量角器',
    clickHandler: () => {
      EventBus.emit({
        event: CanvasEvent.CanvasMeasureToolCreatedEvent,
        payload: {
          type: MeasureToolType.Protractor
        }
      })
    },
    icon: 'MeasureProtractor',
  },
  [ReaderToolType.ShortRuler]: {
    // title: '短尺',
    title: 'ReaderToolTitle_ShortRuler',
    ga: '工具列_測量工具_短尺',
    clickHandler: () => {
      EventBus.emit({
        event: CanvasEvent.CanvasMeasureToolCreatedEvent,
        payload: {
          type: MeasureToolType.ShortRuler
        }
      })
    },
    icon: 'MeasureShortRuler',
  },
  [ReaderToolType.LongRuler]: {
    // title: '長尺',
    title: 'ReaderToolTitle_LongRuler',
    ga: '工具列_測量工具_長尺',
    clickHandler: () => {
      EventBus.emit({
        event: CanvasEvent.CanvasMeasureToolCreatedEvent,
        payload: {
          type: MeasureToolType.LongRuler
        }
      })
    },
    icon: 'MeasureLongRuler',
  },
  [ReaderToolType.IsoscelesTriangle]: {
    // title: '等腰三角形',
    title: 'ReaderToolTitle_IsoscelesTriangle',
    ga: '工具列_測量工具_等腰三角形',
    clickHandler: () => {
      EventBus.emit({
        event: CanvasEvent.CanvasMeasureToolCreatedEvent,
        payload: {
          type: MeasureToolType.IsoscelesTriangle
        }
      })
    },
    icon: 'MeasureIsoscelesTriangle',
  },
  [ReaderToolType.RightTriangle]: {
    // title: '直角三角形',
    title: 'ReaderToolTitle_RightTriangle',
    ga: '工具列_測量工具_直角三角板',
    clickHandler: () => {
      EventBus.emit({
        event: CanvasEvent.CanvasMeasureToolCreatedEvent,
        payload: {
          type: MeasureToolType.RightTriangle
        }
      })
    },
    icon: 'MeasureRightTriangle',
  },
  [ReaderToolType.StampCollection]: {
    // title: '按鈕收納',
    title: 'ReaderToolTitle_StampCollection',
    ga: '工具列_按鈕收納',
    clickHandler: () => {
      EventBus.emit({
        event: ReaderToolsEvent.ToggleStampCollectionBoxShowEvent
      })
      closeToolbox();
    },
    icon: 'StampCollection',
  },
  [ReaderToolType.Undo]: {
    // title: '回復',
    title: 'ReaderToolTitle_Undo',
    ga: '工具列_回復',
    clickHandler: () => {
      EventBus.emit({ event: ReaderToolsEvent.UndoEvent })
    },
    icon: 'Undo',
  },
  [ReaderToolType.Redo]: {
    // title: '取消回復',
    title: 'ReaderToolTitle_Redo',
    ga: '工具列_取消回復',
    clickHandler: () => {
      EventBus.emit({ event: ReaderToolsEvent.RedoEvent })
    },
    icon: 'Redo',
  },
  [ReaderToolType.AnswerInteractiveTool]: {
    // title: '快問快答'
    title: 'ReaderToolTitle_AnswerInteractiveTool',
    icon: 'AnswerInteractiveTool'
  },
  [ReaderToolType.PaiNote]: {
    // title: '派筆記'
    title: 'ReaderToolTitle_PaiNote',
    icon: 'PaiNote'
  },
  [ReaderToolType.SubmitNote]: {
    // title: '筆記回傳'
    title: 'ReaderToolTitle_SubmitNote',
    clickHandler: () => {
      setReaderToolType(ReaderToolType.SubmitNote);
    },
    icon: 'SubmitNote'
  },
  [ReaderToolType.PaiNoteRecord]: {
    // title: '筆記紀錄'
    title: 'ReaderToolTitle_PaiNoteRecord',
    clickHandler: () => {
      EventBus.emit({
        event: ReaderToolsEvent.TogglePaiNoteRecordEvent
      });
    },
    icon: 'PaiNoteRecord'
  },
  [ReaderToolType.SyncAnnotation]: {
    // title: '儲存雲端',
    title: 'ReaderToolTitle_SyncAnnotation',
    ga: '工具列_儲存',
    clickHandler: () => {
      console.log('ReaderToolTitle_SyncAnnotation');
      EventBus.emit({
        event: ReaderToolsEvent.SyncAnnotationToCloud
      })

      EventBus.emit({
        event: ReaderToolsEvent.SetIsOnlineDialogMessage,
        payload:"班級紀錄已存檔於本機"
      })
    },
    icon: 'SyncAnnotation',
  },
};
